export default __webpack_public_path__ + "static/media/btc6x.e77453ae.png";